import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { PDFGenerated } from "../shared/enums/Reports";
import React from "react";
import { Check, Close } from "@mui/icons-material";

interface Props {
  options: ColumnFilterElementTemplateOptions;
}

const pdfGeneratedDropdownItemTemplate = (pdfGeneratedStatus: PDFGenerated) => {
  return (
    <React.Fragment>
      {pdfGeneratedStatus === PDFGenerated.True ? (
        <Check style={{ color: "green" }} />
      ) : (
        <Close style={{ color: "red" }} />
      )}
    </React.Fragment>
  );
};

export function PDFGeneratedFilterDropdown(props: Props) {
  return (
    <Dropdown
      value={props.options.value}
      options={Object.values(PDFGenerated)}
      onChange={(e) => props.options.filterApplyCallback(e.value)}
      className="w-100"
      showClear
      itemTemplate={pdfGeneratedDropdownItemTemplate}
      valueTemplate={pdfGeneratedDropdownItemTemplate}
    />
  );
}
